// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-loyout_App__UI1Rr {
    /* display: flex;
    flex-direction: row;  */

    display: grid;
    grid-template-columns: 2fr 12fr;


    width: 100%;
    height: 100%;

    >div:nth-child(3) {
        border-left: 2px dashed rgb(255, 255, 255);
    }
}

@media (min-width: 768px) {
    .main-loyout_App__UI1Rr {
        >div:nth-child(2) {
            display: none;
        }
    }
}

@media (max-width: 768px) {
    .main-loyout_App__UI1Rr {
        display: flex; 
        grid-template-columns: none;
        flex-direction: column;
        justify-content: start;

        >div:nth-child(1) {
            display: none;
        }

        >div:nth-child(3) {
            border-left: none;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main-loyout/main-loyout.module.css"],"names":[],"mappings":"AAAA;IACI;2BACuB;;IAEvB,aAAa;IACb,+BAA+B;;;IAG/B,WAAW;IACX,YAAY;;IAEZ;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI;QACI;YACI,aAAa;QACjB;IACJ;AACJ;;AAEA;IACI;QACI,aAAa;QACb,2BAA2B;QAC3B,sBAAsB;QACtB,sBAAsB;;QAEtB;YACI,aAAa;QACjB;;QAEA;YACI,iBAAiB;QACrB;IACJ;AACJ","sourcesContent":[".App {\n    /* display: flex;\n    flex-direction: row;  */\n\n    display: grid;\n    grid-template-columns: 2fr 12fr;\n\n\n    width: 100%;\n    height: 100%;\n\n    >div:nth-child(3) {\n        border-left: 2px dashed rgb(255, 255, 255);\n    }\n}\n\n@media (min-width: 768px) {\n    .App {\n        >div:nth-child(2) {\n            display: none;\n        }\n    }\n}\n\n@media (max-width: 768px) {\n    .App {\n        display: flex; \n        grid-template-columns: none;\n        flex-direction: column;\n        justify-content: start;\n\n        >div:nth-child(1) {\n            display: none;\n        }\n\n        >div:nth-child(3) {\n            border-left: none;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `main-loyout_App__UI1Rr`
};
export default ___CSS_LOADER_EXPORT___;
